// src/pages/administrativo/ConfigDFeCertificadoModal.js
import React, { useEffect, useState } from 'react';
import Input from '../../components/input/Input.js';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalHeader from '../../components/modalForm/ModalHeader';
import { useConfigDFe } from '../../contexts/administrativo/ConfigDFeContext';
import { useMessage } from '../../contexts/geral/MessageContext';

const ConfigDFeCertificadoModal = ({
    show,
    onHide,
    configDFe,
    onCertificadoSalvo,
}) => {
    const { salvarCertificadoConfigDFe } = useConfigDFe();
    const { showMessage } = useMessage();
    const [arquivo, setArquivo] = useState(null);
    const [senha, setSenha] = useState('');
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        if (!show) return;

        setArquivo(null);
        setSenha('');
    }, [show]);

    const handleArquivoChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.name.toLowerCase().endsWith('.pfx')) {
            showMessage('Selecione um arquivo .pfx.', 'warning');
            e.target.value = '';
            return;
        }

        setArquivo(file);
    };

    const handleSalvar = async () => {
        if (!configDFe?.id) {
            showMessage('Salve ou selecione uma configuração de DF-e antes de informar o certificado.', 'warning');
            return;
        }

        if (!arquivo) {
            showMessage('Informe o arquivo do certificado digital.', 'warning');
            return;
        }

        if (!senha?.trim()) {
            showMessage('Informe a senha do certificado digital.', 'warning');
            return;
        }

        try {
            setSalvando(true);
            const result = await salvarCertificadoConfigDFe(configDFe.id, arquivo, senha);
            onCertificadoSalvo?.(result);
            onHide();
        } catch (error) {
            showMessage(error?.message || 'Erro ao salvar certificado digital.', 'warning');
        } finally {
            setSalvando(false);
        }
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} largura="600px" zIndex={1070}>
            <ModalHeader>
                <h5 className="modal-title">Certificado Digital</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
            </ModalHeader>
            <ModalBody>
                <div className="form-group">
                    <label className="form-label">Arquivo .pfx:</label>
                    <input
                        type="file"
                        className="form-control form-input"
                        accept=".pfx"
                        onChange={handleArquivoChange}
                        disabled={salvando}
                    />
                </div>

                <div className="form-group mt-3">
                    <Input
                        label="Senha:"
                        type="password"
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                        disabled={salvando}
                        size="100%"
                    />
                </div>

                <div className="form-group mt-3">
                    <Input
                        label="Validade atual:"
                        disabled
                        value={configDFe?.certificadoValidade ? new Date(configDFe.certificadoValidade).toLocaleDateString('pt-BR') : ''}
                        size="100%"
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-secondary" onClick={onHide} disabled={salvando}>
                    Fechar
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSalvar} disabled={salvando}>
                    {salvando ? 'Salvando...' : 'Salvar Certificado'}
                </button>
            </ModalFooter>
        </ModalContainer>
    );
};

export default ConfigDFeCertificadoModal;
